import {
  SET_INCLUDE_PAST_TOURNAMENTS_IN_STATE_FOR_ADMIN_HOME,
  SET_SEARCH_VALUE_IN_STATE_FOR_ADMIN_HOME, 
  SET_SEARCH_RESULT_IN_STATE_FOR_ADMIN_HOME,
  SET_SEARCH_BY_SELECTED_FOR_ADMIN_HOME
} from './constants';

export const setIncludePastTournamentsInState = checked => ({
  type: SET_INCLUDE_PAST_TOURNAMENTS_IN_STATE_FOR_ADMIN_HOME,
  payload: checked
});

export const setSearchValueInState = searchValue => ({
  type: SET_SEARCH_VALUE_IN_STATE_FOR_ADMIN_HOME,
  payload: searchValue
}); 

export const setSearchResultInState = searchResult => ({
  type: SET_SEARCH_RESULT_IN_STATE_FOR_ADMIN_HOME,
  payload: searchResult
});

export const setSearchBySelected = id => ({
  type: SET_SEARCH_BY_SELECTED_FOR_ADMIN_HOME,
  payload: id
}); 



// WEBPACK FOOTER //
// ./src/features/admin/home/actionTypes.js